import { render } from "./IncomesByGroups.vue?vue&type=template&id=1a7dd7d2&scoped=true"
import script from "./IncomesByGroups.vue?vue&type=script&lang=js"
export * from "./IncomesByGroups.vue?vue&type=script&lang=js"

import "./IncomesByGroups.vue?vue&type=style&index=0&id=1a7dd7d2&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7dd7d2"]])

export default __exports__